import { List } from '@mui/material';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import { matchPath } from 'react-router-dom';

export function renderNavItems({ items, pathname, expanded, depth = 0 }) {
  return (
    <List disablePadding>{items.reduce((acc, item) => reduceChildRoutes({ acc, item, pathname, depth, expanded }), [])}</List>
  );
}

export function reduceChildRoutes({ acc, pathname, item, depth, expanded }) {
  const key = item.title + depth;
  const route = item.route;
  const isContentRoute = route?.splitTarget === 'content';

  if (item.items) {
    let open = null;

    if (route?.path && !isContentRoute) {
      open = matchPath(
        {
          path: route.path,
          end: false,
        },
        pathname,
      );
    }

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
        expanded={expanded}
        route={route}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>,
    );
  } else if (route?.accessible) {
    acc.push(
      <NavItem depth={depth} icon={item.icon} info={item.info} key={key} title={item.title} expanded={expanded} route={route} />,
    );
  }

  return acc;
}
